import type {VariantProps} from "class-variance-authority";

import {badgeVariants} from "@/components/ui/badge";

import type {DailyActivityReport} from "../types";

export type DarCodeName = DailyActivityReport["code"]["name"];

type DarBadgeVariant = NonNullable<VariantProps<typeof badgeVariants>["variant"]>;

const TOKEN_TO_VARIANT = {
  green: "success",
  yellow: "warning",
  red: "error",
} as const satisfies Record<string, DarBadgeVariant>;

/** Paint from the English token (`Green` / `green`). Never pass a translated label. */
export function getDarCodeBadgeVariant(name: string | null | undefined): DarBadgeVariant {
  const token = String(name ?? "").toLowerCase();
  return TOKEN_TO_VARIANT[token as keyof typeof TOKEN_TO_VARIANT] ?? "secondary";
}

export const DAR_CODE_BADGE_VARIANTS = {
  Green: "success",
  Yellow: "warning",
  Red: "error",
} as const satisfies Record<DarCodeName, DarBadgeVariant>;

/** @deprecated Use `DAR_CODE_BADGE_VARIANTS` — kept for existing DAR list imports. */
export const BADGE_VARIANTS = DAR_CODE_BADGE_VARIANTS;
